module.exports = __webpack_public_path__ + "media/images/gift-thanks-title-candy-d7b4ad8e9a4939ea9b8ea9588578c1a9.png";